<template>
	<div v-bind:class="['modal-box', {'modal-box--error' : error}]" v-if="visible">
		<div class="modal-content">
			<header>
				<div class="modal-headers">
					<div class="modal-header">{{ title }}</div>
				</div>
			</header>
			<main>
				<p>{{ message }}</p>
				<button class="btn btn-round btn-primary" @click="actionOK">OK</button>
			</main>
		</div>
	</div>
</template>

<script>

import Modal from './../../plugins/AppModal';

export default {
	data() {
		return {
			visible: false,
			error: false,
			title: '',
			message: '',
			onConfirm: {}
		}
	},
	methods: {
		actionClose() {
			this.visible = false
		},
		actionOK() {
			if(typeof this.onConfirm === 'function') {
				this.onConfirm()
			}
			this.actionClose()
		},
		show(params) {
			this.visible = true
			this.error = params.error
			this.title = params.title
			this.message = params.message
			this.onConfirm = params.onConfirm
		}
	},
	beforeMount() {
		Modal.EventBus.$on('show', (params) => {
			this.show(params)
		})
	}
}
</script>

<style scoped>
.modal-box > .modal-content > header {
	padding: 0 20px;
	color: white;
	background: var(--main-color);
}

.modal-box > .modal-content > main {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.modal-box.modal-box--error > .modal-content > header {
	color: white;
	background: #FF5722;
}
.modal-box.modal-box--error > .modal-content > main {
	background: #FBE9E7;
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/AppModal.vue